import { BrowserRouter, Routes, Route } from "react-router-dom";
import { adminRoutes, publicRoutes, secureRoutes } from "./routes/routes";
import './App.css';
import './index.css'

import { ToastContainer } from "react-toastify"; // si tu utilises react-toastify
import "react-toastify/dist/ReactToastify.css";


function App() {

  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* Public routes */}
        {publicRoutes.map(({ path, element }, index) => (
          <Route key={`public-${index}`} path={path} element={element} />
        ))}

        {/* Secure routes */}
        {secureRoutes.map(({ path, element }, index) => (
          <Route key={`secure-${index}`} path={path} element={element} />
        ))}

        {/* Admin routes (nested) */}
        {adminRoutes.map(({ path, element, children }, index) => (
          <Route key={`admin-${index}`} path={path} element={element}>
            {children?.map((child, i) => (
              <Route key={`admin-child-${i}`} path={child.path} element={child.element} />
            ))}
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
